<!-- Temporary Vue bridge for adding time entries from the timesheet panels header. -->
<!-- Prefer Zone-based dialogs for future work instead of extending this wrapper further. -->

<template lang="pug">
div
  TimeEntriesFormDialog(
    v-if="!firstLoad"
    ref="dialog"
    :show="timeEntriesFormDialog.show"
    :type="timeEntriesFormDialog.type"
    :time-entry="selectedTimeEntry"
    :on-save="onSave"
    descriptive-zone-label
    @close="close"
  )
</template>

<script>
import moment from 'moment-timezone';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'TimeEntriesFormAddDialogWired',
  data() {
    return { firstLoad: true };
  },
  computed: {
    ...mapState(['timeEntriesFormDialog']),
    ...mapGetters(['selectedTimeEntry']),
  },
  mounted() {
    this.firstLoad = false;
    document.addEventListener('open-time-entry-add', this.open);
  },
  beforeDestroy() {
    document.removeEventListener('open-time-entry-add', this.open);
  },
  methods: {
    async open(event = {}) {
      const timeEntry = Object.assign({}, this.$store.getters.newTimeEntry);
      const { startTime, stopTime, userId } = event.detail || {};

      if (startTime && stopTime) {
        const zone = this.$store.getters.currentZone?.name;

        Object.assign(timeEntry, {
          start_time: zone ? moment.tz(startTime, zone) : moment(startTime),
          stop_time: zone ? moment.tz(stopTime, zone) : moment(stopTime),
        });
      }

      if (userId) {
        const activeTimeZone = this.$store.state.active_time_zone;

        this.$store.dispatch('setSelectedTimeEntry', { timeEntry });
        await this.$nextTick();
        await this.$refs.dialog.memberChanged({ id: userId });
        this.$store.commit('LOAD_STATE', { active_time_zone: activeTimeZone });
      }

      this.$store.dispatch('openDialog', {
        dialog: 'timeEntriesFormDialog',
        type: startTime && stopTime ? 'provided' : 'add',
        timeEntry,
      });
    },
    onSave() {
      setTimeout(() => window.location.reload(), 2000);
    },
    close() {
      this.$store.dispatch('closeDialog', { dialog: 'timeEntriesFormDialog' });
    },
  },
};
</script>
